import React, { Component } from 'react';
import i18next from "../../i18n";
import { FloatField } from './FloatField';
export class ElevatorDataField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            intake: this.props.value?.intake ? this.props.value.intake: '-',
            outtake: this.props.value?.outtake ? this.props.value.outtake : '-',
            shrink: this.props.value?.shrink ? this.props.value?.shrink : '-'
        };
        this.onInputChange = this.onInputChange.bind(this);
    }
    onInputChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value }, () => {
            if (this.props.onChange) {
                this.props.onChange({
                    target: {
                        name: this.props.name,
                        value: {
                            intake: this.state.intake === '-' ? '' : this.state.intake,
                            outtake: this.state.outtake === '-' ? '' : this.state.outtake,
                            shrink: this.state.shrink === '-' ? '' : this.state.shrink
                        }
                    }
                });
            }
        });
    }

    render() {
        const { intake, outtake, shrink } = this.state;
        const { disabled } = this.props;

        let intakeValue = parseFloat(intake.replaceAll(',', '.').replaceAll(' ', ''));
        let outtakeValue = parseFloat(outtake.replaceAll(',', '.').replaceAll(' ', ''));
        let shrinkValue = parseFloat(shrink.replaceAll(',', '.').replaceAll(' ', ''));
        if (isNaN(intakeValue)) intakeValue = 0.0;
        if (isNaN(outtakeValue)) outtakeValue = 0.0;
        if (isNaN(shrinkValue)) shrinkValue = 0.0;

        const summary = intakeValue - outtakeValue - shrinkValue;

        return (<div className="elevator-data-input">
            <div className="table-block">
                <div className="table-response">
                    <table>
                        <thead>
                            <tr>
                                <th key="emptyHeader" style={{ display: "table-cell" }}>
                                </th>
                                <th key="dataHeader" style={{ display: "table-cell" }}>
                                    <span>{i18next.t("elevatorData.dataHeader")}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ display: "table-cell" }}>
                                    <label className="required">{i18next.t("elevatorData.intakeLabel")}</label>
                                </td>
                                <td style={{ display: "table-cell" }}>{
                                    disabled ?
                                        [
                                            intake,
                                            this.props.check && intake === '-' && <div className="help-block" key="help">{i18next.t("requiredField")}</div>
                                        ] :
                                        <FloatField onChange={this.onInputChange} name="intake" className="form-control table-input" value={intake === '-' ? '' : intake} accuracy={3} onlyPositiove={true} />
                                }</td>
                            </tr>
                            <tr>
                                <td style={{ display: "table-cell" }}>
                                    <label className="required">{i18next.t("elevatorData.outtakeLabel")}</label>
                                </td>
                                <td style={{ display: "table-cell" }}>{
                                    disabled ?
                                        [
                                            outtake,
                                            this.props.check && outtake === '-' && <div className="help-block">{i18next.t("requiredField")}</div>
                                        ] :
                                        <FloatField onChange={this.onInputChange} name="outtake" className="form-control table-input" value={outtake === '-' ? '' : outtake} accuracy={3} onlyPositiove={true} />
                                }</td>
                            </tr>
                            <tr>
                                <td style={{ display: "table-cell" }}>
                                    <label className="required">{i18next.t("elevatorData.shrinkLabel")}</label>
                                </td>
                                <td style={{ display: "table-cell" }}>{
                                    disabled ?
                                        [
                                            shrink,
                                            this.props.check && shrink === '-' && <div className="help-block">{i18next.t("requiredField")}</div>
                                        ] :
                                        <FloatField onChange={this.onInputChange} name="shrink" className="form-control table-input" value={shrink === '-' ? '' : shrink} accuracy={3} onlyPositiove={true} />
                                }</td>
                            </tr>
                            <tr>
                                <td style={{ display: "table-cell" }}>{i18next.t("elevatorData.summaryLabel")}</td>
                                <td style={{ display: "table-cell" }}>{summary.toFixed(3).replace('.', ',')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>);
    }
}